export const mutations = {
    SET_CONTACT_MESSAGE(state, payload) {
        state.contactMessage = payload;
    }
}